import type { TUpdatePessoaJuridicaData } from '@/shared/interfaces/conta.types'
import { HttpService } from '@/shared/lib/http'

export class AtualizarPessoaJuridica extends HttpService {
  execute = async ({ id, ...payload }: TUpdatePessoaJuridicaData) => {
    const response = await this.http.put<void>(`/api/v2/Conta/${id}`, payload)
    return response.data
  }
}
